import React from "react";
import "./SectionDifferentialsRemodeling.css";
import { PageHead } from "../../atoms/PageHead";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../../utils/translations/LanguageContext";
import checkIsMobile from "../../../utils/checkIsMobile";
import { Container, Typography } from "@mui/material";
import Text_Regular_14 from "../../atoms/Text_Regular_14";
export default function SectionDifferentialsRemodeling() {
  const { selectedLanguage } = useLanguage();
  const { t } = useTranslation();
  return (
    <>
      {
        !checkIsMobile() ? (
          <div style={{ marginBottom: "88px" }} >
            <div className="container1">
              <div className="box">
                <div className="group">
                  <div className="overlap-group-wrapper">
                    <div className="overlap-group">
                      <div className="ImageRemodeling1" />
                      <div className="ImageRemodeling2" />
                    </div>
                  </div>
                  <div className="info" id="#services5">
                    <PageHead
                      className="page-head-instance"
                      divClassName="design-component-instance-node"
                      text={t("services")}
                      text1={t("Remodeling")}
                    />
                    <Typography fontSize={20} sx={{ textAlign: "justify", color: "#545454" }}>
                      {t("We are")}
                    </Typography>
                    <Typography fontSize={20} sx={{ textAlign: "justify", color: "#545454" }}>
                      {t("In addition")}
                    </Typography>
                  </div>
                </div>
              </div>
            </div>
            <div className="BoxButton">
              <a
                style={{
                  display: "flex",
                  width: "427px",
                  height: "50px",
                  padding: "8px 16px",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "8px",
                  flexShrink: "0px",
                  borderRadius: "12px",
                  border: "none",
                  transition: "1s ease",
                  textDecoration: "none",
                  background:
                    "var(--token-colors-status-interaction-elements, #51787d)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "var(--slot-colors-brand-colors-base-slot-1, #84A8A9)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor =
                    "var(--token-colors-status-interaction-elements, #51787d)"; // Voltando à cor original no mouseleave
                }}
                href="/blog/Remodeling"
              >
                <Text_Regular_14 value={selectedLanguage === "pt" ? "Conheça nossas obras" : "Get to know our work"}
                  isSelected={true} />
              </a>
            </div>
          </div>
        ) :
          (
            <Container 
            sx={{
              minWidth: 300,
              width: "95%",
              maxWidth: 900,
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              gap: "0.5rem",
            }}>
              <div id="#services5" style={{ width: 100, height: 1, background: "#51787D" }} />
              <Typography fontSize={18} textAlign={"center"} color={"#51787D"}>
                {t("services")}
              </Typography>
              <Typography fontSize={24} textAlign={"center"} color={"#51787D"}>
                {t("Remodeling")}
              </Typography>
              <div style={
                {
                  padding: "1rem",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "1rem",
                }
              }>
                <img src="https://bohocasasstorage.blob.core.windows.net/boho-casas/oakberry.jpg" style={{
                  width: "80vw",
                  height: "40vh",
                  objectFit: "cover",
                  borderRadius: 18,
                }} />
                <img src="https://bohocasasstorage.blob.core.windows.net/boho-casas/arco.jpg" style={{
                  width: "80vw",
                  height: "40vh",
                  objectFit: "cover",
                  borderRadius: 18
                }} />
              </div>
              <Container sx={{
                minWidth: 300,
                width: "95%",
                maxWidth: 900,
                padding: "1rem",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "0.5rem",
              }}>
                <div style={{ width: 100, height: 1, background: "#51787D" }} />
                <Typography fontSize={18} textAlign={"center"} color={"#51787D"}>
                  {t("services")}
                </Typography>
                <Typography fontSize={24} textAlign={"center"} color={"#51787D"}>
                  {t("Remodeling")}
                </Typography>
                <Typography fontSize={18} sx={{ textAlign: "justify", color: "#545454" }}>
                  {t("We are")}
                </Typography>
                <Typography fontSize={18} sx={{ textAlign: "justify", color: "#545454" }}>
                  {t("In addition")}
                </Typography>

                <div className="BoxButton">
                  <a
                    style={{
                      display: "flex",
                      width: "300px",
                      height: "50px",
                      padding: "8px 16px",
                      justifyContent: "center",
                      alignItems: "center",
                      gap: "8px",
                      flexShrink: "0px",
                      borderRadius: "12px",
                      border: "none",
                      transition: "1s ease",
                      textDecoration: "none",
                      background:
                        "var(--token-colors-status-interaction-elements, #51787d)",
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "var(--slot-colors-brand-colors-base-slot-1, #84A8A9)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.backgroundColor =
                        "var(--token-colors-status-interaction-elements, #51787d)";
                    }}
                    href="/blog/Remodeling"
                  >
                    <Text_Regular_14 value={selectedLanguage === "pt" ? "Conheça nossas obras" : "Get to know our work"} isSelected={true} />
                  </a>
                </div>
              </Container>

            </Container>
          )
      }
    </>
  );
}
